module.exports = __webpack_public_path__ + "caf00a3ca8bf10c58b60f61b3dca2d62.png";


/*****************
 ** WEBPACK FOOTER
 ** ./favicon-144.png
 ** module id = 381
 ** module chunks = 0
 **/